/**
 * How to revoke a key, in words — the ONE rendering of `keybookRevocationFor`
 * (@papan/types) for the delete confirm, the leave-org notice and the key's own
 * panels. Deleting an entry removes only Papan's copy; this says what actually
 * stops the value working.
 */
import { useTranslation } from '@papan/i18n'
import { useBrand } from '@papan/brand/react'
import { ExternalLink } from 'lucide-react'
import { keybookRevocationFor } from '@papan/types'

export function RevokeGuidance({ credentialType, provider, className = 'text-xs themed-text-muted leading-snug' }: {
  credentialType?: string | null
  provider?: string | null
  className?: string
}) {
  const { t } = useTranslation('keybook')
  const { productName } = useBrand()
  const r = keybookRevocationFor({ credentialType, provider })
  const link = (url: string, label: string) => (
    <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 underline underline-offset-2 themed-text-secondary hover:themed-text">
      {label}<ExternalLink size={11} />
    </a>
  )
  return (
    <p className={className} data-testid="keybook-revoke-guidance" data-mode={r.mode}>
      {r.mode === 'at-provider'
        ? <>{t('revoke.githubApp', { product: productName })} {link(r.url, t('revoke.openAt', { provider: r.providerLabel }))}</>
        : r.mode === 'papan'
          ? t('revoke.papan', { provider: r.providerLabel })
          : r.providerLabel
            ? <>{t('revoke.atSourceProvider', { provider: r.providerLabel })}{r.url && <>{' '}{link(r.url, t('revoke.openAt', { provider: r.providerLabel }))}</>}</>
            : t('revoke.atSource')}
    </p>
  )
}
